import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getNumber, updateNumber } from 'slice/guessingnumberSlice';
import AdminTable from 'common/AdminTable';
import { toast } from 'react-toastify';

const ListNumber = () => {
    const dispatch = useDispatch();
    const cartData = useSelector((state) => state.guessingNumber);
    const [showModal, setShowModal] = useState(false);
    const [currentProduct, setCurrentProduct] = useState(null);

    useEffect(() => {
        dispatch(getNumber());
    }, [dispatch]);


    const handleEditClick = (product) => {
        setCurrentProduct(product);
        setShowModal(true);
    };

    // Close modal
    const handleCloseModal = () => {
        setShowModal(false);
        setCurrentProduct(null);
    };

    // Handle save in modal
    const handleSave = () => {
        if (currentProduct) {
            dispatch(updateNumber({ id: currentProduct.id, data: currentProduct }));
            toast('Number Updated Successfully!')
            handleCloseModal();
        }
    };

    // Table Headers
    const tableHeaders = [
        { Header: 'Name', accessor: 'name' },
        {
            Header: 'Number 1',
            accessor: 'num1',
        },
        {
            Header: 'Number 2',
            accessor: 'num2',
        },
        {
            Header: 'Number 3',
            accessor: 'num3',
        },
        {
            Header: 'Number 4',
            accessor: 'num4',
        },
        {
            Header: 'Action',
            accessor: '',
            Cell: ({ row }) => (
                <button
                className="btn editbtn mx-1"
                onClick={() => handleEditClick(row.original)} // Correct function
            >
                Update
            </button>
            ),
        },
    ];

    return (
        <div className="container-fluid mt-5">
            <div className='mainheadig mx-4'>
                    <h4 className='text-white font-weight-bold '>Guessing Number List </h4>
                </div>

            {cartData?.data?.length > 0 ? (
                <AdminTable tableHeaders={tableHeaders} tableData={cartData.data} />
            ) : "No Data Found"}

            {/* Edit Modal */}
            {showModal && currentProduct && (
                <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Edit Product</h5>
                                <button type="button" className="close" onClick={handleCloseModal}>
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <form>
                                    <div className="form-group">
                                        <label htmlFor='num1'>Name</label>
                                        <input
                                        id='num1'
                                            type="text"
                                            className="form-control"
                                            value={currentProduct.name}
                                            onChange={(e) =>
                                                setCurrentProduct({ ...currentProduct, name: e.target.value })
                                            }
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor='num2'>Number 1</label>
                                        <input
                                        id='num2'
                                            type="text"
                                            className="form-control"
                                            value={currentProduct.num1}
                                            onChange={(e) =>
                                                setCurrentProduct({ ...currentProduct, num1: e.target.value })
                                            }
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor='num2'>Number 2</label>
                                        <input
                                        id='num2'
                                            type="text"
                                            className="form-control"
                                            value={currentProduct.num2}
                                            onChange={(e) =>
                                                setCurrentProduct({ ...currentProduct, num2: e.target.value })
                                            }
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor='num3'>Nummber 3</label>
                                        <input
                                        id='num3'
                                            type="text"
                                            className="form-control"
                                            value={currentProduct.num3}
                                            onChange={(e) =>
                                                setCurrentProduct({ ...currentProduct, num3: e.target.value })
                                            }
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor='num4'>Number 4</label>
                                        <textarea
                                        id='num4'
                                            className="form-control"
                                            value={currentProduct.num4}
                                            onChange={(e) =>
                                                setCurrentProduct({ ...currentProduct, num4: e.target.value })
                                            }
                                        />
                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>
                                    Close
                                </button>
                                <button type="button" className="btn btn-primary" onClick={handleSave}>
                                    Save changes
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ListNumber;
